import { getAccessToken } from '../context';

// Lightweight fire-and-forget Truvolv event beacon. Uses fetch (not the axios-based makeRequest)
// on purpose so low-level modules like the validators can emit events without pulling axios into
// their module graph — axios is ESM and breaks Jest when transitively imported by a spec.
//
// event is a short key: 'step-started' | 'step-completed' | 'step-viewed' | 'form-invalid' | 'form-errored'.
// stepInfo (for step events) is { step, totalSteps }. The backend validates/dedups and no-ops for
// non-Truvolv orgs, so callers fire unconditionally. Always resolves (never rejects) so a caller
// needing two events ordered can chain on it without a failed beacon breaking the chain.
export function submitTruvolvEvent(event, stepInfo) {
  try {
    const base = process.env.REACT_APP_HEAVYSET_API;
    return fetch(`${base}/appointment/page/api/truvolv-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAccessToken()}`
      },
      body: JSON.stringify({ event, step: stepInfo?.step, totalSteps: stepInfo?.totalSteps })
    }).catch(() => {
      /* best-effort analytics; ignore network errors */
    });
  } catch {
    return Promise.resolve();
  }
}
